import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _PayrollTypeWelfareType, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { PayrollTypeSelect } from "../../PayrollFactor/PayrollTypeSelect";
import { SelectAccountantTree } from "../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../../../admin/configuracion/BudgetID/SelectBudgetID";

interface Props {
    idWelfareEntityType: number;
}

export const PayrollTypeWelfareType = ({ idWelfareEntityType }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_PayrollTypeWelfareType);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfig, setModalConfig] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idWelfareEntityType])

    const getLista = () => {
        instance.getPayrollTypeWelfareTypeCatalog(idWelfareEntityType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(
            err => { console.log(err) }
        )

    }

    const create = () => {
        setBean({});
        setModal({ ...modal, "view": true, "name": "Crear Configuración de Cuenta/Rubro por Tipo de Payroll" });
    }

    const deleteItem = () => {
        instance.deletePayrollTypeWelfareType(bean.IDPayrollTypeWelfareType).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        instance.addPayrollTypeWelfareType(bean.IDPayrollType, idWelfareEntityType, bean.AccountantIDStr, bean.BudgetIDStr).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPayrollTypeWelfareType', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
        { title: 'Cuenta de Gasto', property: 'AccountantIDStrName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: false, evento: () => { setModal({ ...modal, "name": `Editar ${bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Niveles Jerárquicos del Empleo">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <PayrollTypeSelect idSelector={bean.IDPayrollType} onChange={(e) => { setBean({ ...bean, "IDPayrollType": e }) }} label="Tipo de Payroll" />
                            </div>
                            <div className="col-md-12">
                                <SelectAccountantTree onChange={(e) => { setBean({ ...bean, "AccountantIDStr": e.JsonCode }) }} jsonCode={bean.AccountantIDStr} label="Cuenta de Gasto" />
                            </div>
                            <div className="col-md-12">
                                <SelectBudgetID onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode }) }} jsonCode={bean.BudgetIDStr} label="Rubro Presupuestal" />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}